/* eslint-disable no-restricted-globals */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import { Formik } from "formik";
import * as Sentry from "@sentry/react";
import React, { useContext } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import Modal from "../../../../components/common/Modal/Modal";
import { GOHONZON_SUBMISSION } from "../../../../contants/formFields";
import { debounce } from "../../../../utils/helper";
import InputField from "../../../../components/common/new/InputField/InputField";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Button from "../../../../components/common/Button";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import Styles from "./style";
import CrossIcon from "../../../../assets/svg/CrossIcon";
import User from "../../../../services/api/user";

const SUB_TYPE = [
  { key: "VC", value: "VC" },
  { key: "SS", value: "FDT" },
  { key: "EVC", value: "EVC" },
  { key: "OTHER", value: "other" },
];

const SUB_STATUS = [
  { key: "NEW", value: "NEW" },
  { key: "IN PROGRESS", value: "IN_PROGRESS" },
  { key: "ON HOLD", value: "ON_HOLD" },
  { key: "EXPIRED", value: "EXPIRED" },
  { key: "RENEWED", value: "RENEWED" },
];

const SUB_DELIVERY_MODE = [
  { key: "UHG", value: "UHG" },
  { key: "COURIER", value: "COURIER" },
  { key: "E DELIVERY", value: "E_DELIVERY" },
];

function EditSubscription({ open, onClose, application, onRefresh }) {
  const toast = useContext(ToastAlertContext);

  const submitReviewRequest = async (values) => {
    const formattedStartAt = moment(values.startAt.$d).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    const formattedEndAt = moment(values.endAt.$d).format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    try {
      await User.AddSubscription(
        {
          ...values,
          startAt: formattedStartAt,
          endAt: formattedEndAt,
        },
        application?.memberId
      );
      toast.show("Subscription Added Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
        onClose();
      }, 2000);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
      Sentry.captureException(error);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        <Formik
          initialValues={{
            [GOHONZON_SUBMISSION.MEMBER_NAME]: application?.fullName,
            [GOHONZON_SUBMISSION.MEMBER_ID]: application?.memberId,
            [GOHONZON_SUBMISSION.EXPIRY_DATE]: null,
            [GOHONZON_SUBMISSION.START_DATE]: null,
          }}
          enableReinitialize
          onSubmit={debounce(submitReviewRequest)}
        >
          {({ handleChange, values, handleSubmit, errors, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    style={{
                      color: "#8C8C8C",
                      fontSize: "20px ",
                      fontWeight: "500",
                    }}
                  >
                    Edit Subscription
                  </Typography>
                  <Box style={Styles.icon} onClick={onClose}>
                    <CrossIcon />
                  </Box>
                </Box>
                <Box marginTop="10px" color="#183053">
                  <Typography />
                  <Typography variant="small" weight={500} color="#183053">
                    {[
                      application?.areaName,
                      application?.zoneName,
                      application?.regionName,
                      application?.chapterName,
                      application?.districtName,
                      application?.blockName,
                    ]
                      .filter(Boolean)
                      .join("/ ")}
                  </Typography>
                </Box>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <Grid item md={8} sm={12}>
                    <div style={{ padding: "20px 0px 0px 10px" }}>
                      <div style={{ ...Styles.gridContainer }}>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Member Name"
                            name={GOHONZON_SUBMISSION.MEMBER_NAME}
                            value={values[GOHONZON_SUBMISSION.MEMBER_NAME]}
                            error={errors[GOHONZON_SUBMISSION.MEMBER_NAME]}
                            onChange={handleChange}
                            disabled
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Member Id"
                            name={GOHONZON_SUBMISSION.MEMBER_ID}
                            value={values[GOHONZON_SUBMISSION.MEMBER_ID]}
                            error={errors[GOHONZON_SUBMISSION.MEMBER_ID]}
                            onChange={handleChange}
                            disabled
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <Dropdown
                            required
                            inputProps={{ required: true }}
                            name={GOHONZON_SUBMISSION.SUB_TYPE}
                            value={values[GOHONZON_SUBMISSION.SUB_TYPE]}
                            options={SUB_TYPE}
                            label="Subscription Type"
                            onChange={handleChange}
                            showCross
                            handleClearValue={() =>
                              setFieldValue(GOHONZON_SUBMISSION.SUB_TYPE, "")
                            }
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Subscription Number"
                            name={GOHONZON_SUBMISSION.SUBSCRIPTION_NUMBER}
                            value={
                              values[GOHONZON_SUBMISSION.SUBSCRIPTION_NUMBER]
                            }
                            error={
                              errors[GOHONZON_SUBMISSION.SUBSCRIPTION_NUMBER]
                            }
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={GOHONZON_SUBMISSION.START_DATE}
                              label="Start Date"
                              inputFormat="DD/MM/YYYY"
                              minDate={new Date()}
                              value={values?.[GOHONZON_SUBMISSION.START_DATE]}
                              onChange={(newValues) => {
                                setFieldValue(
                                  [GOHONZON_SUBMISSION.START_DATE],
                                  newValues
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                              name={GOHONZON_SUBMISSION.EXPIRY_DATE}
                              label="Expiry Date"
                              inputFormat="DD/MM/YYYY"
                              minDate={new Date()}
                              value={values?.[GOHONZON_SUBMISSION.EXPIRY_DATE]}
                              onChange={(newValues) => {
                                setFieldValue(
                                  [GOHONZON_SUBMISSION.EXPIRY_DATE],
                                  newValues
                                );
                              }}
                              renderInput={(params) => (
                                <InputField {...params} required />
                              )}
                            />
                          </LocalizationProvider>
                        </div>

                        <div style={{ ...Styles.gridItem }}>
                          <InputField
                            label="Volume Id"
                            name={GOHONZON_SUBMISSION.VOLUME}
                            value={values[GOHONZON_SUBMISSION.VOLUME]}
                            error={errors[GOHONZON_SUBMISSION.VOLUME]}
                            onChange={handleChange}
                            required
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <Dropdown
                            required
                            inputProps={{ required: true }}
                            name={GOHONZON_SUBMISSION.SUB_STATUS}
                            value={values[GOHONZON_SUBMISSION.SUB_STATUS]}
                            options={SUB_STATUS}
                            label="Subscription Status"
                            onChange={handleChange}
                            showCross
                            handleClearValue={() =>
                              setFieldValue(GOHONZON_SUBMISSION.SUB_STATUS, "")
                            }
                          />
                        </div>
                        <div style={{ ...Styles.gridItem }}>
                          <Dropdown
                            required
                            inputProps={{ required: true }}
                            name={GOHONZON_SUBMISSION.SUB_DELIVERY_MODE}
                            value={
                              values[GOHONZON_SUBMISSION.SUB_DELIVERY_MODE]
                            }
                            options={SUB_DELIVERY_MODE}
                            label="Subscription Delivery Mode "
                            onChange={handleChange}
                            showCross
                            handleClearValue={() =>
                              setFieldValue(
                                GOHONZON_SUBMISSION.SUB_DELIVERY_MODE,
                                ""
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: 5,
                    padding: "10px 0px 0px 10px",
                  }}
                >
                  <Button
                    variant="contained"
                    style={CommonStyles.buttonStyle}
                    type="submit"
                    label="Submit"
                  />
                  <Button
                    variant="outlined"
                    style={{
                      ...CommonStyles.buttonStyle,
                      marginLeft: "20px",
                    }}
                    onClick={onClose}
                    label="CANCEL"
                  />
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}

export default EditSubscription;
